import { useMemo } from 'react';

import { RecipientKind } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsForm.types';
import { useRecipientIdMetadataMap } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsFormRecipients/DraggableListItemRecipient.utils';
import { getTileIconTypenameFromRecipientKind } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/components/DispositiveProvisionTileIcon';

interface UseSemanticTileKindNodeProps {
  recipientKind: RecipientKind | undefined | null;
  recipientId: string;
}

export function useSemanticTileKindNode({
  recipientId,
  recipientKind,
}: UseSemanticTileKindNodeProps) {
  const recipientIdToMetadata = useRecipientIdMetadataMap();

  return useMemo(() => {
    return {
      __typename: getTileIconTypenameFromRecipientKind(recipientKind),
      isCharitableOrganization: recipientId
        ? recipientIdToMetadata[recipientId]?.isCharitableOrganization
        : false,
      entityKind: recipientId
        ? recipientIdToMetadata[recipientId]?.entityKind
        : undefined,
      inEstateStatus: recipientId
        ? recipientIdToMetadata[recipientId]?.inEstateStatus
        : undefined,
      testamentaryEntityKind: recipientId
        ? recipientIdToMetadata[recipientId]?.testamentaryEntityKind
        : undefined,
    };
  }, [recipientId, recipientIdToMetadata, recipientKind]);
}
